import uniqid from 'uniqid'
import LinkIcon from '@material-ui/icons/Link'
import InstagramIcon from '@material-ui/icons/Instagram'
import YouTubeIcon from '@material-ui/icons/YouTube'
import { XIcon, GooglePlayIcon, AppleIcon } from '../SocialIcons'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => {
  const { social } = project

  const socialLinks = [
    { key: 'link', label: 'website', icon: <LinkIcon /> },
    { key: 'x', label: 'x', icon: <XIcon /> },
    { key: 'instagram', label: 'instagram', icon: <InstagramIcon /> },
    { key: 'youtube', label: 'youtube', icon: <YouTubeIcon /> },
    { key: 'googlePlay', label: 'google play', icon: <GooglePlayIcon /> },
    { key: 'appleStore', label: 'apple store', icon: <AppleIcon /> },
  ].filter(({ key }) => social && social[key])

  return (
    <div className='project'>
      {project.image && (
        <img
          src={
            project.image.startsWith('http')
              ? project.image
              : `${process.env.PUBLIC_URL}/images/${project.image}`
          }
          alt={`${project.name} screenshot`}
          style={{ width: '100%', objectFit: 'cover' }}
        />
      )}

      <h3>{project.name}</h3>

      <p className='project__description'>{project.description}</p>
      {project.stack && (
        <ul className='project__stack'>
          {project.stack.map((item) => (
            <li key={uniqid()} className='project__stack-item'>
              {item}
            </li>
          ))}
        </ul>
      )}

      {socialLinks.length > 0 && (
        <div className='project__links'>
          {socialLinks.map(({ key, label, icon }) => (
            <a
              key={key}
              href={social[key]}
              aria-label={label}
              className='link link--icon'
            >
              {icon}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProjectContainer
